var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.422,
    height: 16,
    viewBox: "0 0 16.422 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_002-euro",
    "data-name": "002-euro",
    d: "M27.659,34.44a7.99,7.99,0,0,1-7.3-4.734H18.462a1.212,1.212,0,1,1,0-2.425h1.243a8.042,8.042,0,0,1,0-1.678H18.462a1.212,1.212,0,0,1,0-2.425h1.892a8,8,0,0,1,12.962-2.394A1.212,1.212,0,1,1,31.6,22.5a5.576,5.576,0,0,0-8.466.68H27.4a1.212,1.212,0,0,1,0,2.425H22.148a5.585,5.585,0,0,0,0,1.678H27.4a1.212,1.212,0,0,1,0,2.425H23.137a5.576,5.576,0,0,0,8.466.68A1.212,1.212,0,0,1,33.317,32.1a7.946,7.946,0,0,1-5.658,2.34Zm-9.2-6.545a.6.6,0,0,0,0,1.2h2.094a.307.307,0,0,1,.284.189,7.39,7.39,0,0,0,12.042,2.385.6.6,0,0,0-.845-.845,6.191,6.191,0,0,1-9.731-1.268.307.307,0,0,1,.266-.462H27.4a.6.6,0,0,0,0-1.2H21.889a.307.307,0,0,1-.3-.248,6.2,6.2,0,0,1,0-2.411.307.307,0,0,1,.3-.248H27.4a.6.6,0,0,0,0-1.2H22.571a.307.307,0,0,1-.266-.462,6.191,6.191,0,0,1,9.731-1.268.612.612,0,0,0,.845,0,.6.6,0,0,0,0-.845A7.385,7.385,0,0,0,20.84,23.6a.307.307,0,0,1-.284.19H18.462a.6.6,0,0,0,0,1.2h1.592a.308.308,0,0,1,.3.353,7.437,7.437,0,0,0,0,2.2.308.308,0,0,1-.3.353Z",
    transform: "translate(-17.25 -18.44)",
    fill: "#356bb0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.67e5fe0a20e9ea0ce78c35b3c47198cb.svg";
export { ForwardRef as ReactComponent };